import { render } from "./chat-side-menu.vue?vue&type=template&id=1c996df8&scoped=true"
import script from "./chat-side-menu.vue?vue&type=script&lang=js"
export * from "./chat-side-menu.vue?vue&type=script&lang=js"

import "./chat-side-menu.vue?vue&type=style&index=0&id=1c996df8&lang=scss"
import "./chat-side-menu.vue?vue&type=style&index=1&id=1c996df8&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c996df8"]])

export default __exports__